import type { Employee } from '../store/slices/employeeSlice';

const employeeSummaryRank = (employee: Employee) => {
  const isActive = !employee.employmentStatus || employee.employmentStatus === 'active';
  const hasLinkedUser = Boolean(employee.userId);
  const parsedUpdatedAt = employee.updatedAt ? Date.parse(employee.updatedAt) : Number.NaN;
  const updatedAt = Number.isFinite(parsedUpdatedAt) ? parsedUpdatedAt : 0;
  return (isActive ? 1_000_000_000_000_000 : 0) +
    (hasLinkedUser ? 1_000_000_000_000 : 0) +
    updatedAt;
};

/**
 * Mirrors the backend monthly-summary recipient rules so batch numbers and
 * employee ranges shown before sending match the server's deterministic slice.
 */
export const getEmployeeSummaryRecipients = (employees: Employee[]) => {
  const canonicalByEmail = new Map<string, Employee>();

  employees
    .filter((employee) => !employee.employmentStatus || employee.employmentStatus === 'active')
    .forEach((employee) => {
      const email = (employee.email || '').trim().toLowerCase();
      if (!email) return;

      const existing = canonicalByEmail.get(email);
      if (!existing || employeeSummaryRank(employee) > employeeSummaryRank(existing)) {
        canonicalByEmail.set(email, employee);
      }
    });

  return Array.from(canonicalByEmail.values()).sort((left, right) =>
    (left.name || '').localeCompare(right.name || '')
  );
};
